// React
import React from 'react';
import { Row, Col, Input, Label } from 'reactstrap';

// Containers Injections
import {
  SelectInput,
  convertEventSelectToTarget,
} from '../../../../containers/componentsInjection';

// Styles
import './numberInputStyle.scss';

export const SplitRepetitionView = ({ validation, formatter }) => {
  const handleFormatInstallmentValue = (value, qty) => {
    if (value && qty) {
      return formatter.format(value / qty);
    } else {
      return formatter.format(value);
    }
  };

  return (
    <Row>
      <Col md={3}>
        <div className="mb-3">
          <Label htmlFor="periodicity" className="form-label">
            Periodicidade
          </Label>
          <SelectInput
            inputId="periodicity"
            className="form-control"
            options={[
              {
                value: 'd',
                label: 'Diário',
              },
              {
                value: 'm',
                label: 'Mensal',
              },
              {
                value: 'w',
                label: 'Semanal',
              },
              {
                value: 'y',
                label: 'Anual',
              },
            ]}
            placeholder="Selecione"
            value={validation.values.periodicity}
            onChange={(eventInput) => {
              validation.handleChange(
                convertEventSelectToTarget('periodicity', eventInput)
              );
            }}
            onBlur={(eventInput) => {
              validation.handleBlur(
                convertEventSelectToTarget('periodicity', eventInput)
              );
            }}
          />
        </div>
      </Col>
      <Col md={3}>
        <div className="mb-3">
          <Label htmlFor="installmentsAmount" className="form-label">
            Número de Parcelas
          </Label>
          <input
            min="0"
            max="100"
            type="number"
            placeholder="Selecione"
            name="installmentsAmount"
            className="form-control"
            onBlur={validation.onBlur}
            onChange={validation.handleChange}
            value={validation.values.installmentsAmount}
          />
        </div>
      </Col>
      <Col md={3} className="d-flex align-items-center">
        <span>
          {validation.values.installmentsAmount} parcelas de R${' '}
          {validation.values.installmentValue
            ? formatter.format(validation.values.balance)
            : handleFormatInstallmentValue(
                validation.values.balance,
                validation.values.installmentsAmount
              )}
        </span>
      </Col>
      <Col md={3} className="d-flex align-items-center">
        <Input
          defaultChecked
          type="checkbox"
          id="installmentValue"
          name="installmentValue"
          onBlur={validation.handleBlur}
          onChange={validation.handleChange}
          value={validation.values.installmentValue}
        />
        <Label htmlFor="installmentValue" className="ms-2" check>
          Valor da Parcela
        </Label>
      </Col>
    </Row>
  );
};
